// vueform.config.(js|ts)

import en from '@vueform/vueform/locales/en'
//import vueform from '@vueform/vueform/dist/vueform' // vue3
import vueform from '@vueform/vueform/dist/vueform.vue2'
import { defineConfig } from '@vueform/vueform'

// You might place these anywhere else in your project
//import '@vueform/vueform/dist/vueform.css';
// siehe app.scss

export default defineConfig({
    theme: vueform,
    locales: { en },
    locale: 'en',
})
